import React, { Component } from 'react'
import { Col, Row, Image, Button, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { Image as NativeImage } from 'react-native';
import { isNullOrUndefined } from 'util';
import { REST_SERVICE_URL_ROOT } from '../../../config/settings';
import {
    IMAGE_SIZE, MODE_ADD, MODE_VIEW, MODE_EDIT, PERSONAL_INFORMATION, ERROR, NOTIF_ERROR, SUCCESS, NOTIF_SUCCESS, PROOF_OF_PAYMENT,
    SUBSCRIBED, UNSUBSCRIBED, DATE_FORMAT, EMPTY_STRING, MAXIMUM_FILESIZE, PROOF_IMAGE, HISTORY_PAYMENTS, NO_HISTORY_PAYMENTS, PAYMENT_LENGTH, ERRORS_LENGTH,
    SECONDARY, CANCEL, SUCCESS_BUTTON, SAVE, BACK, PRIMARY, UPDATE, DANGER, DELETE, SUBSCRIBED_MEMBER, MEMBER_DETAILS, STATUS, START_SUBSCRIPTION, NA, END_SUBSCRIPTION,
    RENEW_MEMBERSHIP, NO, YES, MEMBER_RENEWAL, SUPER_ADMIN_RIGHTS_NUMBER
} from '../../../utils/constants';
import ViewHeader from '../../components/ViewHeader';
import ModuleContainer from '../../components/ModuleContainer';
import { MEMBERS_ROUTE, VIEW_MEMBER_ROUTE } from './routes';
import { FaPencilAlt, FaRegWindowClose, FaArrowLeft, FaTrash } from 'react-icons/fa';
import FormTemplate from '../../components/FormTemplate';
import HeaderComponent from '../../components/HeaderComponent';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
    MSG_DEFAULT_ERROR, PROFILE_IMAGE_REQUIRED, IMAGE_SIZE_MESSAGE, RECOMMENENDED_SIZE, SAVE_CHANGES, MSG_CONFIRM_CHANGES, DELETE_MEMBER, DELETE_MESSAGE,
    PROOF_IMAGE_REQUIRED, MSG_INVALID_IMAGE_TYPE
} from '../../../utils/messages';
import { memberOperations, memberSelector, renewSelector } from './state';
import { SideNotification, isValidImageType, profileImageStyle } from '../../../utils/common';
import ConfirmationModal from '../../components/ConfirmationModal';
import moment from 'moment';
import ModalTemplate from './../../components/ModalTemplate'
import debounce from 'lodash.debounce'


class ViewMember extends Component {

    constructor(props) {
        super(props)
        this.state = {
            mode: MODE_ADD,
            imageFile: null,
            imageFileUrl: null,
            imageProofFile: null,
            imageProofFileUrl: null,
            imageRenewFile: null,
            imageRenewFileUrl: null,
            memberId: 0,
            imageHash: Date.now(),
            initialMemberDetails: null,
            countries: [],
            imageError: false,
            imageProofError: false,
            imageRenewError: false,
            showSaveModal: false,
            memberDetails: null,
            renewDetails: null,
            openModal: false,
            renewalDetails: null,
            paymentId: 0,
            showDeleteModal: false,
            showSaveRenewModal: false,
            imageProofErrorSize: false,
            imageRenewErrorSize: false,
            imageErrorSize: false,
            showCalendarModal: false
        }

        this.memberForm = null;
        this.resetForm = null;
        this.saveChanges = debounce(this.saveChanges.bind(this), 500);
        this.deleteMember = debounce(this.deleteMember.bind(this), 500);
        this.saveChangesRenew = debounce(this.saveChangesRenew.bind(this), 500);
    }



    componentDidMount() {

        let id = this.props.match.params.id;

        if (undefined === id) {
            this.setState({ mode: MODE_ADD })
        } else {
            let type = isNullOrUndefined(this.props.location.state) ? MODE_VIEW : this.props.location.state.type;

            this.setState({ memberId: id, mode: type }, () => {
                this.props.getMemberById(this.state.memberId)
                    .then((response) => {
                        if (ERROR === response.status) {
                            SideNotification(NOTIF_ERROR, response.message)
                            this.props.history.push(MEMBERS_ROUTE)
                        } else {
                            let data = response.data;
                            for (var key in data) {
                                if (isNullOrUndefined(data[key])) {
                                    data[key] = EMPTY_STRING;
                                }
                            }
                            if (SUPER_ADMIN_RIGHTS_NUMBER === data.adminRights) {
                                data.superAdminRights = true;
                                data.adminRights = false;
                            }
                            data.startDate = moment(data.subscriptionStartDate).format(DATE_FORMAT);
                            data.endDate = moment(data.subscriptionEndDate).format(DATE_FORMAT);
                            this.setState({ initialMemberDetails: { MemberModel: data }, renewalDetails: { RenewalModel: { 'subscriptionEndDate': EMPTY_STRING === data.subscriptionEndDate ? moment() : data.subscriptionEndDate, 'paymentDate': moment() } } })
                        }
                    })
                    .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
            })
        }

        this.setState({
            countries: this.props.listOfCountries()
        })

        this.props.getIndustryList()
            .then().catch(() => {
                SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR)
            })


    }

    componentWillReceiveProps(newProps) {
        let data = Object.assign({}, this.state.initialMemberDetails)
        if (!isNullOrUndefined(data.MemberModel) && (data.MemberModel.subscriptionEndDate !== newProps.member.subscriptionEndDate || data.MemberModel.payments.length !== newProps.member.payments.length || EMPTY_STRING === data.MemberModel.subscriptionStartDate)) {
            let newData = newProps.member
            newData.startDate = moment(newData.subscriptionStartDate).format(DATE_FORMAT);
            newData.endDate = moment(newData.subscriptionEndDate).format(DATE_FORMAT);
            this.setState({
                initialMemberDetails: { MemberModel: newData }
            })
        }

    }

    handleImageFile = (event) => {
        if (isNullOrUndefined(event.target.files[0]) || isValidImageType(event.target.files[0])) {
            if (!isNullOrUndefined(event.target.files[0]) && Number(IMAGE_SIZE) < event.target.files[0].size) {
                this.setState({ imageErrorSize: Number(IMAGE_SIZE) < Number(event.target.files[0].size), imageError: false, imageFile: null })
            }
            else {
                this.setState({ imageFile: event.target.files[0], imageErrorSize: false, imageFileUrl: isNullOrUndefined(event.target.files[0]) ? null : URL.createObjectURL(event.target.files[0]) }, () => {
                    MODE_ADD === this.state.mode && this.setState({ imageError: isNullOrUndefined(this.state.imageFile) })
                })
            }
        } else {
            SideNotification(NOTIF_ERROR, MSG_INVALID_IMAGE_TYPE);
        }
    }


    handleImageProofFile = (event) => {
        if (isNullOrUndefined(event.target.files[0]) || isValidImageType(event.target.files[0])) {
            if (!isNullOrUndefined(event.target.files[0]) && Number(IMAGE_SIZE) < Number(event.target.files[0].size)) {
                this.setState({ imageProofErrorSize: Number(IMAGE_SIZE) < Number(event.target.files[0].size), imageProofError: false, imageProofFile: null })
            }
            else {
                this.setState({ imageProofFile: event.target.files[0], imageProofFileUrl: isNullOrUndefined(event.target.files[0]) ? null : URL.createObjectURL(event.target.files[0]), imageProofErrorSize: false }, () => {
                    MODE_ADD === this.state.mode && this.setState({ imageProofError: isNullOrUndefined(this.state.imageProofFile) })
                })
            }
        } else {
            SideNotification(NOTIF_ERROR, MSG_INVALID_IMAGE_TYPE);
        }
    }

    uploadImageContainer = () => {
        return (
            <React.Fragment>
                <Col className="flex-align">
                    <NativeImage
                        source={{ uri: (isNullOrUndefined(this.state.imageFile) ? `${REST_SERVICE_URL_ROOT}/user/image/${this.state.memberId}?${this.state.imageHash}` : this.state.imageFileUrl) }}
                        style={profileImageStyle}
                        resizeMode={(MODE_ADD === this.state.mode && isNullOrUndefined(this.state.imageFile)) ? "contain" : "cover"}
                    />
                    <div className="image-div"><label><b className={this.isViewMode() ? EMPTY_STRING : "required-input"}>Profile Image</b></label><br />
                        {MODE_VIEW !== this.state.mode && (
                            <div>
                                {this.state.imageError && <><label className="formik-error">{PROFILE_IMAGE_REQUIRED}</label><br /></>}
                                {this.state.imageErrorSize && <><label className="formik-error">{IMAGE_SIZE_MESSAGE}</label><br /></>}
                                <input className="prof-image" type='file' id='photo' accept='image/*' onChange={this.handleImageFile} /><br />
                                <b>{RECOMMENENDED_SIZE}</b>
                            </div>

                        )}
                    </div>
                </Col>

            </React.Fragment>

        );
    }

    uploadPaymentImageContainer = () => {
        return (
            <React.Fragment>

                <Col className="flex-align">
                    <div>
                        <Image
                            src={(isNullOrUndefined(this.state.imageProofFile) ? `${REST_SERVICE_URL_ROOT}/user/image/payment/${0}?${this.state.imageHash}` : this.state.imageProofFileUrl)}
                            className="proof-image"
                        />
                        {MODE_VIEW !== this.state.mode && (
                            <center><b>{MAXIMUM_FILESIZE}</b></center>
                        )}
                    </div>
                    <div className="image-div">
                        <label><b className={this.isViewMode() ? EMPTY_STRING : "required-input"}>{this.isViewMode() ? EMPTY_STRING : "Proof Image"}</b></label><br />
                        {MODE_VIEW !== this.state.mode && (
                            <div>
                                {this.state.imageProofError && <><label className="formik-error">{PROOF_IMAGE_REQUIRED}</label><br /></>}
                                {this.state.imageProofErrorSize && <><label className="formik-error">{IMAGE_SIZE_MESSAGE}</label><br /></>}
                                <input type='file' id='photo' accept='image/*' onChange={this.handleImageProofFile} /><br />
                            </div>
                        )}
                    </div>
                </Col>


            </React.Fragment>

        );
    }

    uploadRenewalImageContainer = () => {
        return (
            <React.Fragment>
                <label><b className={this.isViewMode() ? "paymentProof" : "required-input"}>{PROOF_OF_PAYMENT}</b></label><br />

                <Col className="flex-align renew">
                    <Image
                        src={(isNullOrUndefined(this.state.imageRenewFile) ? `${REST_SERVICE_URL_ROOT}/user/image/payment/${this.state.paymentId}?${this.state.imageHash}` : this.state.imageRenewFileUrl)}
                        className="renew-image"
                    />
                    <div className="flex-align renew">
                        <div>
                            {this.state.imageRenewError && <><label className="formik-error">{PROOF_IMAGE_REQUIRED}</label><br /></>}
                            {this.state.imageRenewErrorSize && <><label className="formik-error">{IMAGE_SIZE_MESSAGE}</label><br /></>}
                            <label><b className={this.isViewMode() ? "required-input" : EMPTY_STRING}>{this.isViewMode() ? PROOF_IMAGE : EMPTY_STRING}</b></label><br />
                            <input type='file' id='photo' accept='image/*' onChange={this.handleImageRenewFile} /><br />
                            <b>{MAXIMUM_FILESIZE}</b>
                        </div>
                    </div>
                </Col>


            </React.Fragment>

        );
    }

    listOfPayments = () => {
        let payments = !isNullOrUndefined(this.state.initialMemberDetails) && this.state.initialMemberDetails.MemberModel.payments
        return (
            <React.Fragment>
                <Row className="payment-div">
                    <label className="payment-text"><b>{PAYMENT_LENGTH < payments.length ? HISTORY_PAYMENTS : NO_HISTORY_PAYMENTS}</b></label>
                </Row>
                <Row md={12} className="payments">
                    {payments && payments.map((data, index) => {
                        return (
                            <Col md={4} key={index} className="col-payment">
                                <OverlayTrigger
                                    key={index}
                                    overlay={
                                        <Tooltip>{data.paymentDescription}</Tooltip>
                                    }
                                >
                                    <Row>
                                        <Image
                                            src={`${REST_SERVICE_URL_ROOT}/user/image/payment/${data.paymentId}?${this.state.imageHash}`}
                                            className="payment-image"
                                        />
                                        <div className="view-div">
                                            {data.paymentFileName}
                                            <Button className="viewPayment-button" variant="light" target="_blank" href={`${REST_SERVICE_URL_ROOT}/user/image/payment/${data.paymentId}?${this.state.imageHash}`}>View</Button>
                                        </div>
                                    </Row>
                                </OverlayTrigger>
                            </Col>
                        )
                    })}
                </Row>
            </React.Fragment>
        )
    }

    isViewMode = () => {
        return MODE_VIEW === this.state.mode;
    }

    updateMode = (mode) => {
        if (null !== this.state.initialMemberDetails) {
            this.setState({ mode });
        }
    }

    onCancelClick = () => {
        
        if(!isNullOrUndefined(this.state.initialMemberDetails)){
            this.form.resetForm(this.state.initialMemberDetails);
        }
        
        this.updateMode(MODE_VIEW);
    }


    renderRightButtons = () => {
        switch (this.state.mode) {
            case MODE_ADD: {
                return [
                    { variant: SECONDARY, label: CANCEL, icon: FaRegWindowClose, onClick: () => this.props.history.push(MEMBERS_ROUTE) },
                    { variant: SUCCESS_BUTTON, label: SAVE, icon: FaPencilAlt, onClick: this.onSubmitClick },
                ]
            }
            case MODE_EDIT: {
                return [
                    { variant: SECONDARY, label: CANCEL, icon: FaRegWindowClose, onClick: this.onCancelClick },
                    { variant: SUCCESS_BUTTON, label: SAVE, icon: FaPencilAlt, onClick: this.onSubmitClick },
                ]
            }
            default: {
                return [
                    { variant: SECONDARY, label: BACK, icon: FaArrowLeft, onClick: () => this.props.history.push(MEMBERS_ROUTE) },
                    { variant: PRIMARY, label: UPDATE, icon: FaPencilAlt, onClick: () => this.updateMode(MODE_EDIT) },
                    { variant: DANGER, label: DELETE, icon: FaTrash, onClick: () => this.toggleDelete() },
                ]
            }
        }
    }

    bindSubmitFormik = (submitForm, resetForm) => {
        this.submitForm = submitForm;
        this.resetForm = resetForm;
    };

    updateFormRef = (newForm) => {
        this.form = newForm;
    }

    handleSubmit = (values) => {

        let errors = memberSelector.validateForm(values);

        if (ERRORS_LENGTH === Object.keys(errors).length) {
            let data = values.MemberModel
            delete data.empty // empty

            if (isNullOrUndefined(this.state.imageFile) && MODE_ADD === this.state.mode) {
                this.setState({ imageError: true })
            } else if (isNullOrUndefined(this.state.imageProofFile) && MODE_ADD === this.state.mode) {
                this.setState({ imageProofError: true })
            } else {
                this.setState({ imageError: false, imageProofErrorSize: false, imageProofError: false, imageErrorSize: false, memberDetails: data }, () => this.toggleSave());
            }
        } else {

        }
    }

    handleRenewalSubmit = (values) => {

        let data = values.RenewalModel

        if (isNullOrUndefined(this.state.imageRenewFile)) {
            this.setState({ imageRenewError: true })
        } else {
            this.setState({ imageRenewError: false, imageRenewErrorSize: false, renewDetails: data }, () => this.toggleSaveRenew());
        }


    }

    toggleSave = () => {
        this.setState(prevState => ({ showSaveModal: !prevState.showSaveModal }));
    }

    toggleSaveRenew = () => {
        this.setState(prevState => ({ showSaveRenewModal: !prevState.showSaveRenewModal }));
    }

    onSubmitClick = () => {

        this.form.submitForm();
        if (MODE_ADD === this.state.mode) {
            this.setState({
                imageError: isNullOrUndefined(this.state.imageFile),
                imageProofError: isNullOrUndefined(this.state.imageProofFile)
            })
        }
        else if (MODE_VIEW === this.state.mode) {
            this.setState({
                imageRenewError: isNullOrUndefined(this.state.imageRenewFile)
            })
        }
    }

    saveChanges = () => {

        let values = Object.assign({}, this.state.memberDetails)

        if (MODE_EDIT === this.state.mode) {
            this.props.updateMember(values, this.state.imageFile, this.state.imageProofFile)
                .then(result => {
                    if (SUCCESS === result.status) {
                        this.setState({ mode: MODE_VIEW, showSaveModal: false, imageProofFileUrl: null, imageProofFile: null, initialMemberDetails: { MemberModel: values }, })
                        SideNotification(NOTIF_SUCCESS, result.message);
                    } else {

                        SideNotification(NOTIF_ERROR, result.message);
                    }
                })
                .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
        } else {
            this.props.insertMember(values, this.state.imageFile, this.state.imageProofFile)
                .then(result => {
                    console.log(result)
                    if (SUCCESS === result.status) {
                        SideNotification(NOTIF_SUCCESS, result.message);
                        this.props.history.push({ pathname: VIEW_MEMBER_ROUTE + `/${result.data}`, state: { type: MODE_VIEW } });
                    } else {
                        SideNotification(NOTIF_ERROR, result.message);
                    }
                })
                .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
        }
    }


    saveChangesRenew = () => {
        
        let data = this.state.renewDetails
        data.memberId = this.state.memberId

        this.props.renewMembership(this.state.renewDetails, this.state.imageRenewFile)
            .then(result => {
                if (SUCCESS === result.status) {
                    this.setState({ showSaveRenewModal: false, openModal: false, imageRenewFile: null, renewalDetails: { RenewalModel: { 'subscriptionEndDate': EMPTY_STRING === data.subscriptionEndDate ? moment() : data.subscriptionEndDate, 'paymentDate': moment() } } })
                    SideNotification(NOTIF_SUCCESS, result.message);
                } else {

                    SideNotification(NOTIF_ERROR, result.message);
                }
            })
            .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
    }

    renew = () => {
        this.setState({
            openModal: true
        })
    }

    closeModal = () => {
        this.setState({
            openModal: false,
            imageRenewFile: null,
            paymentId: 0,
            imageRenewError: false,
            imageRenewErrorSize: false
        })
    }

    renderButtons = () => {
        return [
            { variant: SECONDARY, label: CANCEL, icon: FaRegWindowClose, onClick: this.closeModal },
            { variant: SUCCESS_BUTTON, label: SAVE, icon: FaPencilAlt, onClick: this.onSubmitClick }
        ]
    }

    handleImageRenewFile = (event) => {

        if (isNullOrUndefined(event.target.files[0]) || isValidImageType(event.target.files[0])) {
            if (!isNullOrUndefined(event.target.files[0]) && Number(IMAGE_SIZE) < Number(event.target.files[0].size)) {
                this.setState({ imageRenewErrorSize: Number(IMAGE_SIZE) < Number(event.target.files[0].size), imageRenewError: false, imageRenewFile: null })
            }
            else {
                this.setState({ imageRenewFile: event.target.files[0], imageRenewFileUrl: isNullOrUndefined(event.target.files[0]) ? null : URL.createObjectURL(event.target.files[0]), imageRenewErrorSize: false }, () => {
                    MODE_EDIT !== this.state.mode && this.setState({ imageRenewError: isNullOrUndefined(this.state.imageRenewFile) })
                })
            }
        } else {
            SideNotification(NOTIF_ERROR, MSG_INVALID_IMAGE_TYPE);
        }
    }

    toggleDelete = () => {
        this.setState({
            showDeleteModal: !this.state.showDeleteModal
        })
    }

    deleteMember = () => {
        this.props.deleteMember(this.state.memberId)
            .then((result) => {
                if (SUCCESS === result.status) {
                    SideNotification(NOTIF_SUCCESS, result.message);
                    this.props.history.push(MEMBERS_ROUTE)
                } else {
                    SideNotification(NOTIF_ERROR, result.message);
                }
                this.toggleDelete();
            });
    }


    render() {
        let details = !isNullOrUndefined(this.state.initialMemberDetails) && this.state.initialMemberDetails.MemberModel;
        let isSubscribed = details && SUBSCRIBED_MEMBER === details.isSubscribed
        let userType = this.props.isAuthenticated.credentials.accessRights
        let subscriptionStartDate = !isNullOrUndefined(details.subscriptionStartDate) && EMPTY_STRING !== details.subscriptionStartDate
        let subscriptionEndDate = !isNullOrUndefined(details.subscriptionEndDate) && EMPTY_STRING !== details.subscriptionEndDate
        return (
            <ModuleContainer>
                <ViewHeader
                    title={MEMBER_DETAILS}
                    rightButtons={this.renderRightButtons()}
                />
                <Row className="image-row">
                    <Col md={5}>
                        {this.uploadImageContainer()}
                    </Col>
                    {MODE_ADD !== this.state.mode &&
                        <Col md={7} className="flex-align">
                            {STATUS} {isSubscribed ? SUBSCRIBED : UNSUBSCRIBED}<br />
                            {START_SUBSCRIPTION} {subscriptionStartDate ? moment(details.subscriptionStartDate).format(DATE_FORMAT) : NA}<br />
                            {END_SUBSCRIPTION} {subscriptionEndDate ? moment(details.subscriptionEndDate).format(DATE_FORMAT) : NA}<br />
                            {MODE_VIEW === this.state.mode && <Button className="renew-button" variant="light" onClick={() => this.renew()}>{RENEW_MEMBERSHIP}</Button>}
                        </Col>
                    }
                </Row>
                <br /><br /><br /><br />
                <HeaderComponent
                    headerName={PERSONAL_INFORMATION}
                />
                <div>
                    <Col md={10}>

                        <FormTemplate
                            validate={memberSelector.validateForm}
                            formName="members"
                            formClassName={"form-inline-display"}
                            editMode={MODE_ADD !== this.state.mode}
                            readOnly={MODE_VIEW === this.state.mode}
                            initialValues={this.state.initialMemberDetails}
                            bindSubmitFormik={this.bindSubmitFormik}
                            formInputs={this.props.memberForm}
                            selectInput={this.state.countries}
                            selectInputIndustry={this.props.industryList}
                            updateFormRef={this.updateFormRef}
                            handleSubmit={this.handleSubmit}
                            radioInput={this.props.radioInput}
                            userType={userType}
                        />

                    </Col>
                </div>
                <br /><br />
                <HeaderComponent
                    headerName={PROOF_OF_PAYMENT}
                />
                <Row className="image-row">
                    <Col md={6}>
                        {this.uploadPaymentImageContainer()}
                    </Col>
                    {(MODE_ADD !== this.state.mode) &&
                        <Col md={5} className="payments-div">
                            {this.listOfPayments()}
                        </Col>
                    }
                </Row>
                <ConfirmationModal
                    show={this.state.showSaveModal}
                    toggleModal={this.toggleSave}
                    title={SAVE_CHANGES}
                    message={MSG_CONFIRM_CHANGES}
                    modalButtons={[
                        { label: NO, onClick: this.toggleSave, variant: SECONDARY },
                        { label: YES, onClick: this.saveChanges, variant: SUCCESS_BUTTON }
                    ]}
                />

                <ConfirmationModal
                    show={this.state.showSaveRenewModal}
                    toggleModal={this.toggleSaveRenew}
                    title={SAVE_CHANGES}
                    message={MSG_CONFIRM_CHANGES}
                    modalButtons={[
                        { label: NO, onClick: this.toggleSaveRenew, variant: SECONDARY },
                        { label: YES, onClick: this.saveChangesRenew, variant: SUCCESS_BUTTON }
                    ]}
                />

                <ConfirmationModal
                    show={this.state.showDeleteModal}
                    toggleModal={this.toggleDelete}
                    title={DELETE_MEMBER}
                    message={DELETE_MESSAGE}
                    modalButtons={[
                        { label: NO, onClick: this.toggleDelete, variant: SECONDARY },
                        { label: YES, onClick: this.deleteMember, variant: DANGER }
                    ]}
                />

                <ModalTemplate
                    name="renewal"
                    openModal={this.state.openModal}
                    closeModal={() => this.closeModal()}
                    title={MEMBER_RENEWAL}
                    form={this.props.renewalForm}
                    uploadImageContainer={this.uploadRenewalImageContainer}
                    bindSubmitFormik={this.bindSubmitFormik}
                    editorState={this.state.editorState}
                    updateEditorState={this.updateEditorState}
                    renderButtons={this.renderButtons()}
                    updateFormRef={this.updateFormRef}
                    handleSubmit={this.handleRenewalSubmit}
                    initialValues={this.state.renewalDetails}
                    validate={renewSelector.validateForm}
                    editMode={false}
                    readOnly={false}
                    details={details}
                    className={"renewal-modal"}
                />
            </ModuleContainer>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        memberForm: state.members.memberForm,
        isAuthenticated: state.auth,
        radioInput: state.members.radioInput,
        industryList: state.members.industryList,
        member: state.members.member,
        renewalForm: state.members.renewalForm
    }
}

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        listOfCountries: memberOperations.listOfCountries,
        insertMember: memberOperations.insertMember,
        getIndustryList: memberOperations.getIndustryList,
        getMemberById: memberOperations.getMemberById,
        updateMember: memberOperations.updateMember,
        deleteMember: memberOperations.deleteMember,
        renewMembership: memberOperations.renewMembership
    },
    dispatch
)

export default connect(mapStateToProps, mapDispatchToProps)(ViewMember);